<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter :filter-list="table_filter" @search="search" />
    </el-card>
    <el-card>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getUserList"
        :is-row-click="false"
      />
    </el-card>

    <el-dialog title="重置密码" :visible.sync="reset_password.show" width="30%" :before-close="closeResetBox" center>
      <div class="reset_password_main">
        <el-tag type="info">用户：{{ reset_password.name }}</el-tag>
        <el-input v-model="reset_password.password" size="mini" class="reset_password_input" placeholder="请输入新密码" />
        <el-input v-model="reset_password.confirm_password" size="mini" class="reset_password_input" placeholder="请重复输入新密码" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="resetCancel">取 消</el-button>
        <el-button size="mini" type="primary" @click="resetPassword">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改" :visible.sync="edit.show" width="30%" :before-close="closeEditBox" center>
      <edit-box v-if="edit.show" :data="edit.data" @config="editConfigCallback" @cancel="closeEditBox" />
    </el-dialog>

    <el-dialog title="修改绑定广告主" :visible.sync="edit_advertiser.show" width="50%" :before-close="closeEditAdvertiserBox" center>
      <edit-advertiser-box
        v-if="edit_advertiser.show"
        :data="edit_advertiser.data"
        @config="editConfigCallback"
        @cancel="closeEditAdvertiserBox"
      />
    </el-dialog>
  </div>
</template>

<script>
import UserResource from '@/api/user';
const userResource = new UserResource();
import editBox from '@/views/system/user-manage/function/edit';
import editAdvertiserBox from '@/views/system/user-manage/function/edit-advertiser';

export default {
  name: 'UserManage',
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'edit-box': editBox,
    'edit-advertiser-box': editAdvertiserBox,
  },
  data() {
    return {
      table_filter: require('./model/table-filter')(this),
      table_key: require('./model/table-key')(this),
      table_params: { page: 1, limit: 10, name: '' },
      reset_password: { show: false, name: '', id: null, password: null, confirm_password: null },
      edit: { show: false, data: {}},
      edit_advertiser: { show: false, data: {}},
    };
  },
  methods: {
    search(params) {
      Object.assign(this.table_params, params, { page: 1 });
      this.$refs.table.seekTable();
    },
    getUserList(params) {
      return userResource.getUserList(params).then(response => {
        const meta = response.meta || {};
        return {
          list: response.data || [],
          page_info: {
            total_number: Number(meta.total || meta.total_number || 0),
            per_page: Number(meta.per_page || params.limit || 10),
          },
        };
      });
    },
    showResetBox(scope) {
      this.reset_password.name = scope.row.name;
      this.reset_password.id = scope.row.id;
      this.reset_password.show = true;
    },
    closeResetBox(done) {
      this.$confirm('确认关闭？').then(() => {
        done();
        this.emptyResetPasswordData();
      }).catch(() => {});
    },
    resetPassword() {
      const { password, confirm_password } = this.reset_password;
      if (!password) {
        return this.$message({ message: '请输入密码', type: 'warning' });
      }
      if (!confirm_password || confirm_password !== password) {
        return this.$message({ message: '重复密码必须与密码保持一致', type: 'warning' });
      }
      if (password.toString().length < 6) {
        return this.$message({ message: '密码过于简陋，须为6位字符以上', type: 'warning' });
      }
      userResource.resetPassword(this.reset_password).then(() => {
        this.$message({ message: '密码重置成功', type: 'success' });
        this.emptyResetPasswordData();
      });
    },
    resetCancel() {
      this.emptyResetPasswordData();
    },
    emptyResetPasswordData() {
      this.reset_password = { show: false, name: '', id: null, password: null, confirm_password: null };
    },
    showEditBox(scope) {
      this.edit.data = scope.row;
      this.edit.show = true;
    },
    showEditAdvertiserBox(scope) {
      this.edit_advertiser.data = scope.row;
      this.edit_advertiser.show = true;
    },
    editConfigCallback() {
      this.edit.show = false;
      this.edit_advertiser.show = false;
      this.$refs.table.refer();
    },
    closeEditBox(done) {
      this.$confirm('确认关闭？').then(() => {
        this.edit.show = false;
        done();
      }).catch(() => {});
    },
    closeEditAdvertiserBox(done) {
      this.$confirm('确认关闭？').then(() => {
        this.edit_advertiser.show = false;
        done();
      }).catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.reset_password_main .reset_password_input { margin-top: 5px; }
</style>
